import script from "./TestDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./TestDemo.vue?vue&type=script&setup=true&lang=js"

import "./TestDemo.vue?vue&type=style&index=0&id=22a1658e&scoped=true&lang=css"

import exportComponent from "/home/artur/Documents/bemyvega-gitlab/platform-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a1658e"]])

export default __exports__